import { Button } from "react-bootstrap"

import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import { ScheduleStatus } from "../../config/Constants"

interface FormFoxTestANColumnProps {
  row: OrderResultRecord
  prevRow?: OrderResultRecord
  showAuthFormModal: (row: OrderResultRecord) => void
}

function FormFoxTestANColumn(props: FormFoxTestANColumnProps) {
  const { row, prevRow, showAuthFormModal } = props

  const isShowValue = (prevRow === undefined) || (prevRow && ((prevRow.PersonID !== row.PersonID) || (prevRow.FormFoxTestAN !== row.FormFoxTestAN)))
  const isLinkVisible =
    row.FormFoxTestAN !== "" &&
    !row.DateCollected &&
    row.ScheduleStatusID !== ScheduleStatus.Cancelled &&
    !row.IsExpired && isShowValue

  return isLinkVisible ? (
    <Button variant="underline-link pl-1" onClick={() => showAuthFormModal(row)}>
      {row.FormFoxTestAN}
    </Button>
  ) : (
    <div className="text-nowrap ml-1">{isShowValue ? row.FormFoxTestAN : ""}</div>
  )
}

export default FormFoxTestANColumn
